import React from 'react';
import { Link } from 'react-router-dom';
import { Users, FolderOpen, FileText, Clock, TrendingUp } from 'lucide-react';
import { createPageUrl } from '../../utils';

export default function QuickActions({ pendingApprovals }) {
  const actions = [
    {
      label: 'Tambah Pegawai',
      icon: Users,
      page: 'EmployeeForm',
      color: 'text-emerald-600',
      hover: 'hover:bg-emerald-50 hover:border-emerald-300',
    },
    {
      label: 'Arsip Terintegrasi',
      icon: FolderOpen,
      page: 'ArchiveDashboard',
      color: 'text-purple-600',
      hover: 'hover:bg-purple-50 hover:border-purple-300',
    },
    {
      label: 'Aplikasi Kredit Baru',
      icon: FileText,
      page: 'CreditApplicationForm',
      color: 'text-blue-600',
      hover: 'hover:bg-blue-50 hover:border-blue-300',
    },
    {
      label: 'Pending Approval',
      icon: Clock,
      page: 'ApprovalList',
      color: 'text-red-600',
      hover: 'hover:bg-red-50 hover:border-red-300',
      badge: pendingApprovals,
    },
  ];

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-6 pb-3">
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-[#c9a227]" />
          Aksi Cepat
        </h3>
      </div>
      <div className="p-6 pt-0">
        <div className="grid grid-cols-2 gap-3">
          {actions.map(action => (
            <Link key={action.page} to={createPageUrl(action.page)}>
              <button
                className={`w-full h-auto py-4 flex flex-col items-center gap-2 border rounded-md bg-white ${action.hover} relative transition-colors`}
              >
                <action.icon className={`w-6 h-6 ${action.color}`} />
                <span className="text-sm">{action.label}</span>
                {action.badge > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full text-xs flex items-center justify-center">
                    {action.badge}
                  </span>
                )}
              </button>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
